import { ReactNode } from "react"

export interface StatusTitleProps {
  children: ReactNode
}

export function StatusTitle({ children }: StatusTitleProps) {
  return <span className="block text-sm font-medium uppercase tracking-wider text-fg-subtle">{children}</span>
}
